var LAYOUT = {
    FULLWIDTH: 'fullwidth',
    SIDEBARLEFT: 'sidebar-left',
    FULLWIDTH_LITE_HEADER: 'fullwidth-lite-header',
    FULLWIDTH_LITE_HEADER_NO_FOOTER: 'fullwidth-lite-header-no-footer',
    CONTAINER_LITE_HEADER_NO_FOOTER: 'container-lite-header-no-footer'
};
export default LAYOUT;
